export const FETCH_POLICY_START = "FETCH_POLICY_START";
export const FETCH_POLICY_SUCCESS = "FETCH_POLICY_SUCCESS";
export const FETCH_POLICY_FAILURE = "FETCH_POLICY_FAILURE";
export const FETCH_POLICY_PDF_START = "FETCH_POLICY_PDF_START";
export const FETCH_POLICY_PDF_SUCCESS = "FETCH_POLICY_PDF_SUCCESS";
export const FETCH_POLICY_PDF_FAILURE = "FETCH_POLICY_PDF_FAILURE";
